import { AssignedComments } from "./AssignedComments/AssignedComments";
import CounterCard from "./CounterCard";
import LatestEdits from "./LatestEdits";
import LatestList from "./LatestList";
import OverTimeChart from "./OverTimeChart";
import PercentageChart from "./PercentageChart";
import { PercentageList } from "./PercentageList/PercentageList";

export const chartMapper = {
    CounterCard,
    OverTimeChart,
    LatestList,
    PercentageChart,
    PercentageList,
    LatestEdits,
    AssignedComments,
};

export { AssignedComments, CounterCard, LatestEdits, LatestList, OverTimeChart, PercentageChart, PercentageList };
